import { Box, Tooltip, Typography, IconButton } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import default_theme from "assets/themes/themes";

const TooltipLabel = ({ label, tooltip }) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      {label}

      <Tooltip
        title={
          <Typography sx={{ fontSize: 13, lineHeight: 1.4, color: "#fff" }}>
            {tooltip}
          </Typography>
        }
        arrow
        slotProps={{
          tooltip: {
            sx: {
              backgroundColor: default_theme.palette.other.figmaBlue,
              padding: "10px 14px",
              borderRadius: "8px",
              boxShadow: 3,
            },
          },
          arrow: {
            sx: {
              color: default_theme.palette.other.figmaBlue,
            },
          },
        }}
      >
        <IconButton size="small">
          <InfoOutlinedIcon
            sx={{
              fontSize: 16,
              color: default_theme.palette.other.figmaBlue,
            }}
          />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default TooltipLabel;